<script>
  import Icon from "@iconify/svelte";

  export let text = "No items";
  export let simple = false;
</script>

<div
  class={`${$$props.class} flex gap-2 text-textpbg-700 text-xs items-center`}
  class:complex={!simple}
>
  <Icon icon="line-md:coffee-half-empty-twotone-loop" class="w-5 h-5" />
  <div>{text}</div>
</div>

<style lang="postcss" global>
  :local(.complex) {
    @apply text-textpbg-700 border-pbg-200/50 bg-pbg-50/30 items-center justify-center py-8 text-center border-2 border-dotted rounded-lg px-6;
  }
</style>
